import CachedResourceStore from '@/store/modules/CachedResourceStore'
import { CargoProject } from '@/models/CargoProject'

export default new CachedResourceStore<CargoProject>(CargoProject, {
	namespaced: true
})
